

export const getFormsByType=(forms: SmartRxForm[],  type: "SMARTRX" | "UASSIST") => {
    return forms.filter((item: SmartRxForm) =>  item.type === type) || [];
}

export const getFormByName=(forms,  type: "SMARTRX" | "UASSIST", name: string) => {
    return forms.find((item: SmartRxForm) =>  item.type === type && item.name.toLowerCase() === name.toLowerCase()) || {};
}